<template>
	<div>
		<div class="pc-agree-box">
			<div>
				<span @click="handleClick" class="agree" :class="{ 'no-agree': !isAgree }"></span>
				{{ copy.lead }}
				<a :href="serviceUrl" target="_blank">{{ copy.linkTerms }}</a>
				{{ copy.mid }}
				<a :href="privacyUrl" target="_blank">{{ copy.linkPrivacy }}</a>
			</div>
		</div>
		<!-- <div class="pc-subscribe-box">
      <div>
        <span @click="handleClick" class="agree" :class="{ 'no-agree': !isAgree }"></span>
        我希望通過電子報接收
        <a href="/activitycollection/userServiceAgreement" target="_blank">獨家優惠</a>
        和
        <a href="/dist/protocol/website/privacy-policy-statement?lang=zh_tw" target="_blank">最新先知命局會員訊息</a>。
        我了解并可以隨時聯系先知命局取消訂閲。
      </div>
    </div> -->
	</div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
	/** UI 語言：`zh-TW`（預設）| `en` */
	locale: {
		type: String,
		default: "zh-TW",
	},
});

const moduleValue = defineModel();

const isAgree = ref(true);

const protocolLang = computed(() => (props.locale === "en" ? "en" : "zh_tw"));

const serviceUrl = computed(
	() => `/dist/protocol/website/service-agreement?lang=${protocolLang.value}`
);
const privacyUrl = computed(
	() => `/dist/protocol/website/privacy-policy-statement?lang=${protocolLang.value}`
);

const copy = computed(() =>
	props.locale === "en"
		? {
				lead: "I have read and agree to SeerQ's ",
				linkTerms: "Terms of Service",
				mid: " and ",
				linkPrivacy: "Privacy Policy",
			}
		: {
				lead: "我已閱讀並同意先知命局的",
				linkTerms: "《服務協議》",
				mid: "及",
				linkPrivacy: "《私隱政策聲明》",
			}
);

const handleClick = () => {
	isAgree.value = !isAgree.value;

	moduleValue.value = isAgree.value;
};
</script>

<style lang="scss" scoped>
.pc-agree-box,
.pc-subscribe-box {
	margin-bottom: 22px;
	display: flex;
	font-family: Source Han Sans CN;
	font-size: 16px;
	color: #666666;
	line-height: 24px;

	.agree {
		margin-bottom: -2px;
		display: inline-block;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: url("@/assets/images/icon_agree.png") no-repeat center center/ 100% 100%;
		cursor: pointer;
	}

	.no-agree {
		background: url("@/assets/images/icon_no_agree.png") no-repeat center center/ 100% 100%;
	}

	img {
		width: 20px;
		height: 20px;
		margin-right: 8px;
		cursor: pointer;
	}

	a {
		color: #c8843c;
	}
}

.pc-agree-box {
	margin-bottom: 14px;
}
</style>
